// Decorative brand imagery only (hero + category tiles). These are NOT product
// listings and contain no commerce data. Swap freely for your own brand art.
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1700190827565-7b6247de4838?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const CATEGORY_ART = {
  fashion:
    "https://images.unsplash.com/photo-1614676471928-2ed0ad1061a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  electronics:
    "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  home:
    "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  beauty:
    "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  accessories:
    "https://images.unsplash.com/photo-1603805752838-aa579d77da72?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  audio:
    "https://images.unsplash.com/photo-1615655406736-b37c4fabf923?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
};
